<template>
  <v-footer
    app
    color="topBar"
    dark
    class="cm-footer py-3"
    height="60"
  >
    <div>Copyright &copy; 2009-{{ year }} The Canadian Outdoor Equipment Co.</div>
    <v-spacer />
    <div>
      <a href="/terms-and-conditions/">Terms</a>
      <span class="mx-2" style="opacity: 0.5">|</span>
      <a href="/privacy-policy/">Privacy Policy</a>
      <span class="mx-2" style="opacity: 0.5">|</span>
      <a href="/return-policy/">Return Policy</a>
    </div>
  </v-footer>
</template>

<style lang="scss">
.cm-footer {
  color: rgba(200, 200, 200, 0.9) !important;
  font-size: 12px;
  a {
    color: inherit !important;
  }
}
</style>

<script>
export default {
  data () {
    return {
      year: (new Date()).getFullYear()
    }
  }
}
</script>
